import React, { Component, useState } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from './components/Layout';
import Home  from './components/Home';
import Login from './components/Login';
import New from './components/New';
import Recall from './components/Recall';
import Update from './components/Update';
import Summary from './components/Summary';
import Form from './components/Form';
import axios from 'axios';
import PrivateRoute from './components/PrivateRoute';
import './custom.css';
import { StylesProvider } from '@material-ui/core/styles';


export default class App extends Component {
    static displayName = App.name;  


    render() {
        axios.interceptors.response.use(function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            return response;
        }, function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
                // Do something with response error
                if (error.response.config.method == "get") {
                    if (401 === error.response.status) {
                        window.location.href = 'login?origin=' + window.location.pathname;
                    }
                }
            return Promise.reject(error);
        });
        var referrer = document.referrer;
        console.log("referrer url", referrer);
        console.log(process.env.PUBLIC_URL);
        const api_regex = /^\/api\/.*/
        console.log(window.location.pathname);
        // if using "/api/" in the pathname, don't use React Router
        if (window.location.pathname.indexOf('/api/') > -1) {
            console.log('api');
            return <div /> // must return at least an empty div
        } else {  
  
            
            return (
                <StylesProvider injectFirst>           
                    <Layout>                        
                        <Switch>
                            <Route exact path='/login' component={Login} />   
                            <Route exact path='/' component={Home} />                 
                            <Route exact path='/home' component={Home} />                          
                            <PrivateRoute path='/new' component={New} />
                            <PrivateRoute path='/update' component={Update} />
                            <PrivateRoute path='/form/:uniqueID/:startSection?' component={Form} />
                            <PrivateRoute exact path='/recall' component={Recall} />
                            <PrivateRoute path='/summary/:type/:uniqueID/:realID?' component={Summary} />                         
                        </Switch>                       
                    </Layout>
                </StylesProvider>
                );
         
        }
  }
}
